export default __webpack_public_path__ + "static/media/blackcliff_slasher.4693af54.png";